export default __webpack_public_path__ + "static/compressed-f0787ddbb04b81e280ccb013ca065523.mp4";